// extracted by mini-css-extract-plugin
export default {"root":"IconDogFriendly_root__XnAGM"};